import React, { useEffect, useRef } from 'react';
import useStyles from './styles';
import anime from 'animejs'
import useWindowResizeHandler from '@src/shared/hooks/use-window-resize-handler';
let pathAnimation : anime.AnimeInstance
let markerAnimation :  anime.AnimeInstance
const InitialAnimatedBackground = () => {
    const classes = useStyles();
    const animatedBGElementRef = useRef<HTMLDivElement>(null)
    const pathImageContainerRef = useRef<HTMLDivElement>(null)
    const animatedMarkerImageContainerRef = useRef<HTMLDivElement>(null)
    const { isWindowResizing } = useWindowResizeHandler(1);
    
    const correctPathBGHorizontalPosition = () => {
        window.requestAnimationFrame(()=> {
            const container =  document.getElementById('main-initial-content-container')
            if (container && animatedMarkerImageContainerRef.current) {
                const rects = animatedMarkerImageContainerRef.current.getBoundingClientRect()
                container.style.backgroundPositionX = (-692 + rects.left) + 'px'
                container.style.backgroundPositionY = (-365 + rects.top + (document.documentElement.scrollTop))+ 'px'
            }
           })
    }
    const scrollHandler = () => {
        const container =  document.getElementById('main-initial-content-container')
        if (!markerAnimation.completed && !markerAnimation.paused && !pathAnimation.completed && !pathAnimation.paused) {
            return
        }

        markerAnimation.restart()
        markerAnimation.pause()
        pathAnimation.restart()
        pathAnimation.pause()
        if (!animatedBGElementRef.current) { return }

        const pathAnimationAfterScroll = anime({
            targets:pathImageContainerRef.current,
            keyframes:[
                { backgroundPosition:['right', 'right'], width:['620px','575px']},
                { backgroundPosition:['right', 'right'], width:['575px','366px']},
                { backgroundPosition:['right', 'right'], width:['366px','141px']},
                { backgroundPosition:['right', 'right'], width:['141px','61px']}
            ],
            easing: 'linear',
            duration:1500,
            autoplay:false
          });

         const markerAnimationAfterScroll = anime({
            targets:animatedMarkerImageContainerRef.current,
            keyframes:[
                { backgroundPosition:['20px 97px, 97% 0px', '66px 54px, 97% 0px'] },
                { backgroundPosition:['66px 54px, 97% 0px', '265px 54px, 97% 0px']},
                { backgroundPosition:['265px 54px, 97% 0px', '490px 54px, 97% 0px'] },
                { backgroundPosition:['490px 54px, 97% 0px', '570px 25px, 97% 0px']},
            ],
            easing: 'linear',
            duration:1500,
            autoplay:false
          });

        pathAnimationAfterScroll.seek(pathAnimation.duration * document.documentElement.scrollTop   / 1600);
        markerAnimationAfterScroll.seek(markerAnimation.duration * document.documentElement.scrollTop  / 1600); 

        if (document.documentElement.scrollTop <= 677) {
            window.requestAnimationFrame(()=> {
                if (document.documentElement.scrollTop >= 63 && animatedBGElementRef.current) {
                    animatedBGElementRef.current.style.top = (document.documentElement.scrollTop - 63) + 'px'
                }
                if (container && animatedMarkerImageContainerRef.current) {
                    const rects = animatedMarkerImageContainerRef.current.getBoundingClientRect()
                    container.style.backgroundPositionY = (-365 + rects.top + (document.documentElement.scrollTop) )+ 'px'
                }
            })
        } else if (document.documentElement.scrollTop < 63) {
            if (container && animatedMarkerImageContainerRef.current) {
                const rects = animatedMarkerImageContainerRef.current.getBoundingClientRect()
                container.style.backgroundPositionY = (-365 + rects.top)+ 'px'
            }
            animatedBGElementRef.current.style.top = '0px' 
        }

    }

    const activateBackgroundAnimation = () => {
        pathAnimation = anime({
            targets:pathImageContainerRef.current,
            keyframes:[
                { backgroundPosition:['right', 'right'], width:['620px','575px'],delay:1000 },
                { backgroundPosition:['right', 'right'], width:['575px','366px'],delay:1500 },
                { backgroundPosition:['right', 'right'], width:['366px','141px'],delay:1 },
                { backgroundPosition:['right', 'right'], width:['141px','61px'],delay:500 }
            ],
            easing: 'linear',
            duration:1500,
            autoplay:false
          });

          markerAnimation = anime({
            targets:animatedMarkerImageContainerRef.current,
            keyframes:[
                { backgroundPosition:['20px 97px, 97% 0px', '66px 54px, 97% 0px'],delay:1000 },
                { backgroundPosition:['66px 54px, 97% 0px', '265px 54px, 97% 0px'],delay:1500 },
                { backgroundPosition:['265px 54px, 97% 0px', '490px 54px, 97% 0px'],delay:1 },
                { backgroundPosition:['490px 54px, 97% 0px', '570px 25px, 97% 0px'],delay:500 },
            ],
            easing: 'linear',
            duration:1500,
            autoplay:false
          });
    }

    useEffect(()=> {
        window.addEventListener('scroll', scrollHandler)
        return () => {
            window.removeEventListener('scroll', scrollHandler)
        }
    }, [animatedBGElementRef])

    useEffect(()=> {
        if (animatedMarkerImageContainerRef.current && pathImageContainerRef.current) {
            activateBackgroundAnimation()
        }
    }, [animatedMarkerImageContainerRef, pathImageContainerRef])

    useEffect(()=>{
        correctPathBGHorizontalPosition()
    },[pathImageContainerRef, isWindowResizing])

    return <div className={classes.parallaxContainer}>
            <div className={classes.animatedBG} ref={animatedBGElementRef}>
                <div className={'animated-marker-image-container'} ref={animatedMarkerImageContainerRef}></div>
                <div className={'path-image-container'} ref={pathImageContainerRef}></div>
            </div>
        </div>
}

export default InitialAnimatedBackground